import * as types from './types'

export const mutations = {
	[types.CLEAR_DOCUMENTS] (state) {
		state.documents.myOperations = []
		state.documents.personalEstate = []
		state.documents.justificatifs = []
		state.documents.lcbft = []
		state.documents.subscriptions = []
		state.documents.autre.shared = []
		state.documents.autre.private = []
	},
	[types.ADD_DOCUMENT] (state, data) {
		if (state.documents[data.type]) {
			state.documents[data.type].push(data.document)
		} else if (typeof state.documents.autre[data.type] !== 'undefined') {
			state.documents.autre[data.type].push(data.document)
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Documents/mutations.js